export default __webpack_public_path__ + "65fdb83b306ca5d8d49445c986e754b1.png";